export default "__VITE_ASSET__CX21AjXd__"